import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { NAV, telefoonMenu } from "./navConfig";
import { MeerSheet } from "./MeerSheet";

const Telling = ({ count, testid }) => count > 0 && (
  <span data-testid={testid} className="absolute -top-1.5 left-1/2 ml-1.5 inline-flex items-center justify-center min-w-[17px] h-[17px] px-1 rounded-full bg-rose-600 text-white text-[9.5px] font-bold leading-none font-mono">{count}</span>
);

const KNOP = "relative flex-1 min-w-0 min-h-[56px] flex flex-col items-center justify-center gap-1 text-[10.5px] font-semibold transition-colors";

// v18 A1: vaste onderbalk op de telefoon (< 768px).
export const BottomBar = ({ user, counts, onbHasNew, wachtwoordHint, onWachtwoord, onUitloggen }) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { balk, meer } = telefoonMenu(user);
  const meerItems = meer.map((k) => ({ key: k, ...NAV[k] }));
  const meerActief = meerItems.some((n) => pathname.startsWith(n.to));
  const meerTelling = meerItems.reduce((s, n) => s + (n.countKey ? counts[n.countKey] || 0 : 0), 0);
  return (
    <>
      <nav data-testid="bottom-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-zinc-200" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="flex">
          {balk.map((k) => {
            const n = NAV[k];
            return (
              <NavLink key={k} to={n.to} data-testid={`bnav-${k}`}
                className={({ isActive }) => `${KNOP} ${isActive ? "text-zinc-900" : "text-zinc-400"}`}>
                {({ isActive }) => (<>
                  {isActive && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-7 h-[3px] bg-zinc-900 rounded-sm" />}
                  <span className="relative"><n.icon className="h-5 w-5" /><Telling count={n.countKey ? counts[n.countKey] || 0 : 0} testid={`bnav-badge-${k}`} /></span>
                  <span className="truncate max-w-full px-1">{n.kort || n.label}</span>
                </>)}
              </NavLink>
            );
          })}
          <button type="button" data-testid="bnav-meer" aria-pressed={open} onClick={() => setOpen(true)}
            className={`${KNOP} ${meerActief || open ? "text-zinc-900" : "text-zinc-400"}`}>
            {meerActief && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-7 h-[3px] bg-zinc-900 rounded-sm" />}
            <span className="relative"><MoreHorizontal className="h-5 w-5" />
              <Telling count={meerTelling} testid="bnav-badge-meer" />
              {/* v19-N6 F5: met een teller staat het stipje linksonder, zodat het de teller niet bedekt */}
              {onbHasNew && <span data-testid="bnav-meer-new-dot" className={`absolute h-2 w-2 rounded-full bg-rose-500 ${meerTelling ? "-bottom-0.5 -left-1 ring-2 ring-white" : "-top-0.5 -right-1"}`} />}
              {wachtwoordHint && <span data-testid="bnav-meer-wachtwoord-dot" className="absolute -top-0.5 -left-1 h-2 w-2 rounded-full bg-amber-400" />}
            </span>
            <span>Meer</span>
          </button>
        </div>
      </nav>
      <MeerSheet open={open} onOpenChange={setOpen} user={user} items={meerItems} counts={counts} onbHasNew={onbHasNew} wachtwoordHint={wachtwoordHint}
        onWachtwoord={onWachtwoord} onUitloggen={onUitloggen} />
    </>
  );
};
